export default __webpack_public_path__ + "static/media/bg_awads_large.39f79d3c.jpg";